import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import FrontexLogo from '@/assets/images/frontex.png'

export default {
  name: 'FrontexTermsOfUseModal',
  extends: BaseModal,
  data: function () {
    return {
      FrontexLogo,
    }
  },
}
